module.exports = __webpack_public_path__ + "static/media/shield-check.f92b0717.svg";